import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { FireAndFlowerMemberCardStackContentViewModel } from './fire-and-flower-member-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-fire-and-flower-member-card-stack-content',
  templateUrl: './fire-and-flower-member-card-stack-content.component.html',
  styleUrls: ['./fire-and-flower-member-card-stack-content.component.scss'],
  providers: [FireAndFlowerMemberCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireAndFlowerMemberCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: FireAndFlowerMemberCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
